<div class="qb-detail-card p-3 mb-3">
  <div class="flex items-center gap-3 cursor-pointer" (click)="toggleExpanded()">
    <i class="pi" [class.pi-chevron-right]="!expanded" [class.pi-chevron-down]="expanded"></i>
    <span class="font-semibold uppercase tracking-wide text-sm">Pending Manufacturer Cancellations</span>
    <span
      class="text-xs px-2 py-1 rounded"
      [class.bg-orange-100]="totalCount > 0"
      [class.text-orange-800]="totalCount > 0"
      [class.bg-gray-100]="totalCount === 0"
      [class.text-gray-600]="totalCount === 0"
    >
      {{ totalCount }} row{{ totalCount === 1 ? '' : 's' }},
      {{ manufacturerCount }} manufacturer{{ manufacturerCount === 1 ? '' : 's' }}
    </span>
    <span class="grow"></span>
    <button
      pButton
      type="button"
      class="p-button-raised p-button-sm"
      icon="pi pi-send"
      [disabled]="totalCount === 0 || loading"
      (click)="$event.stopPropagation(); flushNow()"
    >
      <span>Flush Now</span>
    </button>
    <button
      pButton
      type="button"
      class="p-button-text p-button-sm"
      icon="pi pi-refresh"
      [disabled]="loading"
      (click)="$event.stopPropagation(); refresh()"
      title="Refresh"
    ></button>
  </div>

  <div *ngIf="expanded" class="mt-3">
    <div *ngIf="totalCount === 0" class="text-sm text-gray-600 italic p-2">
      Nothing pending. The next scheduled flush runs every 15 minutes.
    </div>
    <div *ngIf="totalCount > 0" class="max-h-64 overflow-y-auto border rounded">
      <table class="w-full text-sm">
        <thead class="sticky top-0 bg-white z-10">
          <tr class="text-left border-b">
            <th class="p-2">Manufacturer</th>
            <th class="p-2">P/O</th>
            <th class="p-2">P/O Detail</th>
            <th class="p-2">Queued</th>
            <th class="p-2">By</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let group of groups">
            <tr class="bg-gray-50 font-semibold">
              <td class="p-2" colspan="5">
                {{ group.manufacturerName }} —
                {{ group.rows.length }} pending row{{ group.rows.length === 1 ? '' : 's' }}
              </td>
            </tr>
            <tr *ngFor="let row of group.rows" class="border-b">
              <td class="p-2 pl-6"></td>
              <td class="p-2">{{ row.PoHeaderId }}</td>
              <td class="p-2">{{ row.PoDetailId }}</td>
              <td class="p-2">{{ row.QueuedTs | date: 'short' }}</td>
              <td class="p-2">{{ row.QueuedByUserInit }}</td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
